import * as React from 'react';
import { connect } from 'react-redux';
import { Container, Navbar, NavbarBrand } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
//& typeof VerifyCheckStore.actionCreators
//& { submit: any }; // ... plus action creators we've requested
//<div >{this.props.processState}</div>
//<div >{this.props.creditUnion.name}</div>
class NavMenu extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            isOpen: false
        };
        this.toggle = () => {
            this.setState({
                isOpen: !this.state.isOpen
            });
        };
    }
    render() {
        var cuLogoStyle = {
            backgroundImage: "url(data:image/svg+xml;base64," + this.props.creditUnion.logoImageBase64 + ")"
        };
        return (React.createElement("header", null,
            React.createElement(Navbar, { className: "navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow mb-3", light: true },
                React.createElement(Container, null,
                    React.createElement(NavbarBrand, { tag: Link, to: "/" },
                        React.createElement("div", { className: "vmacLogo" })),
                    React.createElement(NavbarBrand, { tag: Link, to: "/" },
                        React.createElement("div", { className: "cuLogo", style: cuLogoStyle }, " "))))));
    }
}
export default connect((state) => state.verifyCheck)(NavMenu);
/*
 <NavbarToggler onClick={this.toggle} className="mr-2"/>
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={this.state.isOpen} navbar>
                            <ul className="navbar-nav flex-grow">
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/">Home</NavLink>
                                </NavItem>
                            </ul>
                        </Collapse>
 */ 
//# sourceMappingURL=NavMenu.js.map